import { get, post, put, del } from '../apiService';

export interface CrudService<TDto, TCreate, TUpdate> {
  getAll: () => Promise<TDto[]>;
  getById: (id: number) => Promise<TDto>;
  create: (dto: TCreate) => Promise<TDto>;
  update: (id: number, dto: TUpdate) => Promise<TDto>;
  remove: (id: number) => Promise<void>;
}

export function createCrudService<TDto, TCreate, TUpdate>(
  basePath: string
): CrudService<TDto, TCreate, TUpdate> {
  return {
    getAll: () => get<TDto[]>(basePath),
    getById: (id: number) => get<TDto>(`${basePath}/${id}`),
    create: (dto: TCreate) => post<TDto>(basePath, dto),
    update: (id: number, dto: TUpdate) => put<TDto>(`${basePath}/${id}`, dto),
    remove: (id: number) => del(`${basePath}/${id}`),
  };
}
